(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-contact-10x"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Native About contact form (OS-812, about_contact_form_fix_2026-08-31_brief.md):
    // POSTs to the funnel Worker's /webhooks/site-contact route, mirroring
    // apply-10x.liquid's own native-form wiring exactly (same SITE_TOKEN, same
    // "confirm only on 2xx, error-preserves-input on failure" contract). Only
    // present when form_style is "native" (About's own instance); Apply's
    // instance of this same section keeps the Tally iframe branch untouched.
    var WORKER_URL = 'https://10x-funnel.10xpformance.workers.dev/webhooks/site-contact';
    var SITE_TOKEN = '456afc944f94440dc09e2e8131910c452155c64117e59274dd8679b838043dc6';

    function collectAnswers(form) {
      var field = function (name) {
        var el = form.querySelector('[name="' + name + '"]');
        return el ? el.value : '';
      };
      return {
        name: field('name'),
        email: field('email'),
        message: field('message'),
      };
    }

    function initContactForm(form) {
      var wrap = form.closest('.acontact10x__form');
      var confirm = wrap.querySelector('[data-10x-contact-confirm]');
      var errorEl = form.querySelector('[data-10x-contact-error]');
      var submitErrorEl = form.querySelector('[data-10x-contact-submit-error]');
      var submitBtn = form.querySelector('button[type="submit"]');

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (errorEl) errorEl.hidden = true;
        if (submitErrorEl) submitErrorEl.hidden = true;

        if (!form.checkValidity()) {
          form.reportValidity();
          if (errorEl) errorEl.hidden = false;
          return;
        }

        if (submitBtn) submitBtn.disabled = true;
        fetch(WORKER_URL, {
          method: 'POST',
          headers: { 'content-type': 'application/json', 'x-site-token': SITE_TOKEN },
          body: JSON.stringify(collectAnswers(form)),
        }).then(function (res) {
          if (!res.ok) throw new Error('site-contact POST failed: ' + res.status);
          form.hidden = true;
          if (confirm) confirm.hidden = false;
        }).catch(function () {
          if (submitErrorEl) submitErrorEl.hidden = false;
          if (submitBtn) submitBtn.disabled = false;
        });
      });
    }

    function init() {
      document.querySelectorAll('[data-10x-contact-form]').forEach(initContactForm);
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-follow-along-10x"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function tileMarkup(url, handleUrl, alt) {
      var a = document.createElement('a');
      a.href = handleUrl;
      a.target = '_blank';
      a.rel = 'noopener';
      var img = document.createElement('img');
      img.src = url;
      img.width = 300;
      img.height = 300;
      img.loading = 'lazy';
      img.alt = alt;
      a.appendChild(img);
      return a;
    }

    function extractUrl(item) {
      return item.mediaUrl || item.media_url || item.imageUrl || item.image || item.url || item.thumbnailUrl || null;
    }

    function initFollowAlong(root) {
      var feedUrl = root.getAttribute('data-feed-url');
      if (!feedUrl) return;
      var handleUrl = root.getAttribute('data-handle-url');
      var track = root.querySelector('.afollow10x__track');

      fetch(feedUrl)
        .then(function (res) { return res.ok ? res.json() : Promise.reject(); })
        .then(function (data) {
          var items = Array.isArray(data) ? data : (data.posts || data.items || data.data || []);
          var urls = items.map(extractUrl).filter(Boolean);
          if (!urls.length) return;
          var frag = document.createDocumentFragment();
          urls.concat(urls).forEach(function (url) {
            frag.appendChild(tileMarkup(url, handleUrl, 'Instagram post'));
          });
          track.innerHTML = '';
          track.appendChild(frag);
        })
        .catch(function () {
          /* Feed unreachable: the curated stand-in tiles already rendered stay as-is. */
        });
    }

    function initPause(root) {
      var btn = root.querySelector('[data-10x-follow-pause]');
      var track = root.querySelector('.afollow10x__track');
      if (!btn || !track) return;
      btn.addEventListener('click', function () {
        var paused = track.classList.toggle('is-paused');
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.querySelector('.visually-hidden').textContent = paused ? 'Play the Instagram scroll' : 'Pause the Instagram scroll';
      });
    }

    function init() {
      document.querySelectorAll('[data-10x-follow-along]').forEach(function (root) {
        initFollowAlong(root);
        initPause(root);
      });
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-hero-pillars-10x"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // B2 (round 2b, 2026-08-29, A1/A2): ported EXACTLY from the LOCKED
    // mockup `about_hero_pillars_2026-08-28.html` (v28)'s own inline
    // script, logic unchanged, only scoped to this section's root instead
    // of the whole document. The previous port's own click-time eqPillars()
    // re-measurement (added to chase the same close-height bug) was itself
    // a deviation from the locked reference and part of why it stayed
    // broken on live: the v28 script never calls eqPillars() from the click
    // handler AT ALL, only on load/resize. Equal rest height is measured
    // ONCE (all cards closed, their natural rest height), then min-height
    // is never touched again -- a card opening grows past its own
    // min-height via the max-height expansion in CSS, and a card closing
    // shrinks back to that untouched min-height with nothing left to race
    // against a mid-transition offsetHeight read.
    function initPillars(root) {
      var grid = root.querySelector('.apil10x__grid');
      var cards = Array.prototype.slice.call(root.querySelectorAll('.apil10x__card'));
      if (!grid || !cards.length) return;

      function eqPillars() {
        cards.forEach(function (c) { c.style.minHeight = ''; });
        if (window.matchMedia('(max-width: 900px)').matches) return;
        var h = Math.max.apply(null, cards.map(function (c) { return c.offsetHeight; }));
        cards.forEach(function (c) { c.style.minHeight = h + 'px'; });
      }

      window.addEventListener('load', eqPillars);
      var eqT;
      window.addEventListener('resize', function () {
        clearTimeout(eqT);
        eqT = setTimeout(eqPillars, 150);
      });
      eqPillars();

      cards.forEach(function (card) {
        var btn = card.querySelector('.apil10x__head');
        btn.addEventListener('click', function () {
          var wasOpen = card.classList.contains('is-open');
          cards.forEach(function (c) {
            c.classList.remove('is-open');
            c.querySelector('.apil10x__head').setAttribute('aria-expanded', 'false');
          });
          if (!wasOpen) {
            card.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            grid.classList.add('has-open');
          } else {
            grid.classList.remove('has-open');
          }
        });
      });
    }

    function init() {
      document.querySelectorAll('[data-10x-about-pillars]').forEach(initPillars);
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apply-10x"]) return;
  try {
    
  (function () {
    // Site form wiring fix (site_form_wiring_fix_2026-08-29_brief.md, OS-767): the
    // funnel Worker route this form POSTs to (10x-funnel repo, src/index.js
    // handleSiteApplyWebhook). SITE_TOKEN is public by design, not a secret: any
    // value shipped to every visitor's browser can't be kept confidential, so it
    // filters blind/scripted hits against the route rather than gating a human
    // (see the Worker's siteFormAuthorized() docstring).
    var WORKER_URL = 'https://10x-funnel.10xpformance.workers.dev/webhooks/site-apply';
    var SITE_TOKEN = '456afc944f94440dc09e2e8131910c452155c64117e59274dd8679b838043dc6';

    // Collects every answer into the JSON shape the Worker's siteApplyLead()
    // mapper expects: the three named inputs, notes/consent, then each visible
    // pill-group's selection(s) keyed by its own data-10x-apply-group name (the
    // goal group also carries the chosen branch letter), plus any populated
    // "Other" free-text box. Hidden branch groups are skipped, same rule the
    // validation pass below already uses.
    function collectAnswers(form) {
      var field = function (name) {
        var el = form.querySelector('[name="' + name + '"]');
        return el ? el.value : '';
      };
      var data = {
        full_name: field('full_name'),
        email: field('email'),
        phone: field('phone'),
        notes: field('notes'),
        consent: !!(form.querySelector('[name="consent"]') || {}).checked,
        answers: {},
      };

      var groups = Array.prototype.slice.call(form.querySelectorAll('[data-10x-apply-group]'));
      groups.forEach(function (groupEl) {
        if (groupEl.closest('[hidden]')) return;
        var key = groupEl.getAttribute('data-10x-apply-group');
        var optsWrap = groupEl.querySelector('.opts');
        if (!optsWrap) return;
        var selected = Array.prototype.slice.call(optsWrap.querySelectorAll('.opt.is-sel'))
          .map(function (o) { return o.textContent.trim(); });
        if (!selected.length) return;
        data.answers[key] = optsWrap.classList.contains('multi') ? selected : selected[0];
        if (key === 'goal') {
          var selectedGoal = optsWrap.querySelector('.opt.is-sel');
          if (selectedGoal) data.answers.goal_branch = selectedGoal.getAttribute('data-branch');
        }
      });

      ['event_other', 'target_other', 'direction_other', 'matters_other'].forEach(function (name) {
        var el = form.querySelector('[name="' + name + '"]');
        if (el && el.value && !el.closest('[hidden]')) data[name] = el.value;
      });

      var q = new URLSearchParams(window.location.search), utm = {};
      ["utm_source","utm_medium","utm_campaign","utm_content","utm_term"].forEach(function (k) { var v = q.get(k); if (v) utm[k] = v.slice(0, 100); });
      data.utm = utm;
      return data;
    }

    function initApply(form) {
      var section = form.closest('.apply10x');
      var confirm = section.querySelector('[data-10x-apply-confirm]');
      var errorEl = form.querySelector('[data-10x-apply-error]');
      var submitErrorEl = form.querySelector('[data-10x-apply-submit-error]');
      var submitBtn = form.querySelector('button[type="submit"]');

      // Pill selection: single-select groups clear siblings; .multi groups
      // toggle independently (capped at data-max if set). NOTHING is
      // pre-selected server-side; this is the only place .is-sel is added.
      var groups = Array.prototype.slice.call(form.querySelectorAll('.opts'));
      groups.forEach(function (group) {
        var multi = group.classList.contains('multi');
        var max = +group.getAttribute('data-max') || 0;
        var opts = Array.prototype.slice.call(group.querySelectorAll('.opt'));
        opts.forEach(function (opt) {
          opt.addEventListener('click', function () {
            if (multi) {
              var selected = group.querySelectorAll('.opt.is-sel').length;
              if (!opt.classList.contains('is-sel') && max && selected >= max) return;
              opt.classList.toggle('is-sel');
            } else {
              opts.forEach(function (o) { o.classList.remove('is-sel'); });
              opt.classList.add('is-sel');
            }

            // Goal question drives which branch is visible.
            if (group.hasAttribute('data-10x-apply-goal')) {
              var branch = opt.getAttribute('data-branch');
              form.querySelectorAll('[data-10x-apply-branch]').forEach(function (b) {
                var show = b.getAttribute('data-10x-apply-branch') === branch;
                b.hidden = !show;
                if (!show) {
                  // Leaving a branch clears its own selections/other text,
                  // so switching goals never leaves a stale hidden answer.
                  b.querySelectorAll('.opt.is-sel').forEach(function (o) { o.classList.remove('is-sel'); });
                  b.querySelectorAll('.otherbox').forEach(function (ob) { ob.hidden = true; });
                  b.querySelectorAll('.otherbox input').forEach(function (i) { i.value = ''; });
                }
              });
            }

            // "Other" reveal within this same group.
            if (group.classList.contains('hasother')) {
              var otherBox = group.parentElement.querySelector('.otherbox');
              var otherOpt = group.querySelector('.opt--other');
              if (otherBox) {
                var otherOn = !!(otherOpt && otherOpt.classList.contains('is-sel'));
                otherBox.hidden = !otherOn;
                if (!otherOn) {
                  var input = otherBox.querySelector('input');
                  if (input) input.value = '';
                }
              }
            }
          });
        });
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (errorEl) errorEl.hidden = true;
        if (submitErrorEl) submitErrorEl.hidden = true;

        // Validate: plain inputs via required, plus every visible
        // data-required pill group needs at least one .is-sel.
        var valid = form.checkValidity();
        var requiredGroups = Array.prototype.slice.call(form.querySelectorAll('[data-required="true"]'));
        requiredGroups.forEach(function (group) {
          if (group.closest('[hidden]')) return;
          if (!group.querySelectorAll('.opt.is-sel').length) valid = false;
        });

        if (!valid) {
          form.reportValidity();
          if (errorEl) errorEl.hidden = false;
          return;
        }

        // T1 (site_form_wiring_fix_2026-08-29_brief.md): POST to the funnel
        // Worker; the confirmation only shows on a 2xx (Scenario A). A failed
        // POST shows the submit-error element and leaves every answer in
        // place for a retry, never a false success (Scenario B, the exact
        // defect class this build fixes).
        if (submitBtn) submitBtn.disabled = true;
        fetch(WORKER_URL, {
          method: 'POST',
          headers: { 'content-type': 'application/json', 'x-site-token': SITE_TOKEN },
          body: JSON.stringify(collectAnswers(form)),
        }).then(function (res) {
          if (!res.ok) throw new Error('site-apply POST failed: ' + res.status);
          form.hidden = true;
          if (confirm) confirm.hidden = false;
        }).catch(function () {
          if (submitErrorEl) submitErrorEl.hidden = false;
          if (submitBtn) submitBtn.disabled = false;
        });
      });
    }

    function init() {
      document.querySelectorAll('[data-10x-apply-form]').forEach(initApply);
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-system-tabbed-10x"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSystem(root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
      if (!tabs.length) return;
      function select(index, focus) {
        tabs.forEach(function (tab, i) {
          var on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          tab.classList.toggle('is-selected', on);
          var panel = panels[i];
          if (panel) {
            panel.classList.toggle('is-active', on);
            if (on) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
          }
        });
        if (focus) tabs[index].focus();
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(i, false); });
        tab.addEventListener('keydown', function (e) {
          var n = tabs.length, idx = null;
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') idx = (i + 1) % n;
          else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') idx = (i - 1 + n) % n;
          else if (e.key === 'Home') idx = 0;
          else if (e.key === 'End') idx = n - 1;
          if (idx !== null) { e.preventDefault(); select(idx, true); }
        });
      });
    }
    function init() {
      document.querySelectorAll('[data-10x-csystem]').forEach(initSystem);
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coaching-faq-10x"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaq(root) {
      var items = Array.prototype.slice.call(root.querySelectorAll('.cfaq10x__item'));
      items.forEach(function (item) {
        var btn = item.querySelector('.cfaq10x__q');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var wasOpen = item.classList.contains('is-open');
          items.forEach(function (other) {
            other.classList.remove('is-open');
            var otherBtn = other.querySelector('.cfaq10x__q');
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
          });
          if (!wasOpen) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });

      var more = root.parentElement.querySelector('[data-10x-coaching-faq-more]');
      if (more) {
        more.addEventListener('click', function () {
          var expanded = more.getAttribute('aria-expanded') === 'true';
          items.forEach(function (item) {
            if (item.classList.contains('cfaq10x__item--more')) {
              if (expanded) { item.setAttribute('hidden', ''); } else { item.removeAttribute('hidden'); }
            }
          });
          more.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          more.textContent = expanded ? 'See more questions' : 'See fewer questions';
        });
      }
    }
    function init() {
      document.querySelectorAll('[data-10x-coaching-faq]').forEach(initFaq);
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coaching-system-ring-10x"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // B3: the same geometry mock_ring.html itself uses (symmetric 7-node
    // circle, angles -90 + i*360/7, 16-degree gap between nodes), just
    // centred/scaled to the pre-fix build's own 720x720 frame instead of
    // the mock's 1000x800 demo canvas, so the ring renders at its full
    // intended size with the original component icons. Generates BOTH the
    // 7 static grey track segments and the single interactive progress
    // segment from one function, so they can never drift apart.
    var N = 7, R = 300, CX = 360, CY = 360, GAP = 16;
    var SVGNS = 'http://www.w3.org/2000/svg';

    function pt(angleDeg, r) {
      var a = (angleDeg * Math.PI) / 180;
      return [CX + r * Math.cos(a), CY + r * Math.sin(a)];
    }

    function arcPath(a1, a2) {
      var p1 = pt(a1, R), p2 = pt(a2, R);
      var large = ((a2 - a1) % 360) > 180 ? 1 : 0;
      return 'M ' + p1[0].toFixed(1) + ' ' + p1[1].toFixed(1) +
        ' A ' + R + ' ' + R + ' 0 ' + large + ' 1 ' +
        p2[0].toFixed(1) + ' ' + p2[1].toFixed(1);
    }

    var angles = [];
    for (var a = 0; a < N; a++) angles.push(-90 + (a * 360) / N);

    function buildTrack(svg) {
      // 7 segments, one per edge between adjacent nodes (seg[i] runs from
      // node i to node i+1), gapped at both ends so the line aims through
      // each icon's centre and never touches it. Returned as an ordered
      // array so select() can address seg[i-1] and seg[i] directly, same
      // indexing the mock's own segs[] uses.
      var segs = [];
      for (var i = 0; i < N; i++) {
        var next = (i + 1) % N;
        var a1 = angles[i] + GAP, a2 = angles[next] - GAP;
        if (a2 < a1) a2 += 360;
        var seg = document.createElementNS(SVGNS, 'path');
        seg.setAttribute('d', arcPath(a1, a2));
        seg.setAttribute('class', 'cring10x__seg');
        svg.appendChild(seg);
        segs.push(seg);
      }
      return segs;
    }

    function initRing(root) {
      var trackSvg = root.querySelector('[data-10x-ring-track]');
      var selectors = Array.prototype.slice.call(root.querySelectorAll('[data-10x-ring-select]'));
      var segs = trackSvg ? buildTrack(trackSvg) : [];
      if (!selectors.length) return;

      function select(index) {
        selectors.forEach(function (el) {
          var on = +el.getAttribute('data-10x-ring-select') === index;
          el.classList.toggle('is-active', on);
          if (el.hasAttribute('aria-pressed')) el.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        root.querySelectorAll('[data-10x-ring-panel]').forEach(function (p) {
          p.classList.toggle('is-active', +p.getAttribute('data-10x-ring-panel') === index);
        });
        root.querySelectorAll('[data-10x-ring-lane]').forEach(function (l) {
          l.classList.toggle('is-active', +l.getAttribute('data-10x-ring-lane') === index);
        });
        // C-3: BOTH arcs adjacent to the active node go Ember -- the one
        // entering it (seg[index-1]) and the one leaving it (seg[index]);
        // every other segment resets to grey.
        var left = (index - 1 + N) % N, right = index;
        segs.forEach(function (s) { s.classList.remove('is-hot'); });
        if (segs[left]) segs[left].classList.add('is-hot');
        if (segs[right]) segs[right].classList.add('is-hot');
      }

      selectors.forEach(function (el) {
        el.addEventListener('click', function () { select(+el.getAttribute('data-10x-ring-select')); });
      });

      var nodes = Array.prototype.slice.call(root.querySelectorAll('.cring10x__node'));
      nodes.forEach(function (el, i) {
        el.addEventListener('keydown', function (e) {
          var n = nodes.length, idx = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') idx = (i + 1) % n;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') idx = (i - 1 + n) % n;
          else if (e.key === 'Home') idx = 0;
          else if (e.key === 'End') idx = n - 1;
          if (idx !== null) { e.preventDefault(); select(idx); nodes[idx].focus(); }
        });
      });

      select(0);
    }
    // LAUNCH POLISH (2026-09-07): THE MOBILE ACCORDION. Independent of
    // initRing above -- the ring is desktop-only below 1024px (CSS hides
    // .cring10x__wrap entirely) so this never runs alongside it. Same
    // one-open-at-a-time contract as the FAQ accordion (coaching-faq-10x.liquid).
    function initRingAcc(root) {
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-10x-ring-acc-item]'));
      items.forEach(function (item) {
        var btn = item.querySelector('.cring10x__acc-q');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var wasOpen = item.classList.contains('is-open');
          items.forEach(function (other) {
            other.classList.remove('is-open');
            var otherBtn = other.querySelector('.cring10x__acc-q');
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
          });
          if (!wasOpen) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    }

    function init() {
      document.querySelectorAll('[data-10x-ring]').forEach(initRing);
      document.querySelectorAll('[data-10x-ring-acc]').forEach(initRingAcc);
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-10x"]) return;
  try {
    
  (function () {
    // Site form wiring fix (site_form_wiring_fix_2026-08-29_brief.md, OS-767): the
    // funnel Worker route this form POSTs to (10x-funnel repo, src/index.js
    // handleSiteNewsletterWebhook), subscribing to Klaviyo list SnP4c9. SITE_TOKEN
    // is public by design, same non-secret spam filter as the Apply form's own
    // (sections/apply-10x.liquid); see the Worker's siteFormAuthorized() docstring.
    var WORKER_URL = 'https://10x-funnel.10xpformance.workers.dev/webhooks/site-newsletter';
    var SITE_TOKEN = '456afc944f94440dc09e2e8131910c452155c64117e59274dd8679b838043dc6';

    document.querySelectorAll('[data-10x-newsletter]').forEach(function (form) {
      var wrap = form.parentElement;
      var confirmEl = wrap ? wrap.querySelector('[data-10x-newsletter-confirm]') : null;
      var errorEl = wrap ? wrap.querySelector('[data-10x-newsletter-error]') : null;
      var emailInput = form.querySelector('[name="email"]');
      var submitBtn = form.querySelector('button[type="submit"]');

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }
        if (confirmEl) confirmEl.hidden = true;
        if (errorEl) errorEl.hidden = true;
        if (submitBtn) submitBtn.disabled = true;

        fetch(WORKER_URL, {
          method: 'POST',
          headers: { 'content-type': 'application/json', 'x-site-token': SITE_TOKEN },
          body: JSON.stringify({ email: emailInput ? emailInput.value : '' }),
        }).then(function (res) {
          if (!res.ok) throw new Error('site-newsletter POST failed: ' + res.status);
          form.hidden = true;
          if (confirmEl) confirmEl.hidden = false;
        }).catch(function () {
          if (errorEl) errorEl.hidden = false;
          if (submitBtn) submitBtn.disabled = false;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["is-this-for-you-10x"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(form) {
      var boxes = Array.prototype.slice.call(form.querySelectorAll('.itfy10x__check'));
      var result = form.querySelector('[data-10x-itfy-result]');
      if (!boxes.length || !result) return;
      function update() {
        var anyChecked = boxes.some(function (b) { return b.checked; });
        result.hidden = !anyChecked;
      }
      boxes.forEach(function (b) { b.addEventListener('change', update); });
    }
    document.querySelectorAll('[data-10x-itfy]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup-10x"]) return;
  try {
    
  (function () {
    var SEEN_COOKIE = '10x_np_seen';
    var SUBSCRIBED_COOKIE = '10x_np_subscribed';
    var SEEN_DAYS = 30;
    var SUBSCRIBED_DAYS = 400; // practical browser Max-Age cap; the closest to "permanent" a cookie gets
    var SCROLL_FRACTION = 0.5;
    var TIME_MS = 40000;
    var WORKER_URL = 'https://10x-funnel.10xpformance.workers.dev/webhooks/site-newsletter';
    var SITE_TOKEN = '456afc944f94440dc09e2e8131910c452155c64117e59274dd8679b838043dc6';

    function hasCookie(name) {
      return document.cookie.split('; ').indexOf(name + '=1') !== -1;
    }

    function setCookie(name, days) {
      var expires = new Date();
      expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
      var cookie = name + '=1; expires=' + expires.toUTCString() + '; path=/; SameSite=Lax';
      if (window.location.protocol === 'https:') cookie += '; Secure';
      document.cookie = cookie;
    }

    if (hasCookie(SUBSCRIBED_COOKIE) || hasCookie(SEEN_COOKIE)) return;

    var popup = document.querySelector('[data-10x-newsletter-popup]');
    if (!popup) return;

    var closeBtn = popup.querySelector('[data-10x-newsletter-popup-close]');
    var form = popup.querySelector('[data-10x-newsletter-popup-form]');
    var confirmEl = popup.querySelector('[data-10x-newsletter-popup-confirm]');
    var errorEl = popup.querySelector('[data-10x-newsletter-popup-error]');
    var emailInput = form.querySelector('[name="email"]');
    var submitBtn = form.querySelector('button[type="submit"]');
    var triggered = false;

    function showPopup() {
      if (triggered) return;
      triggered = true;
      window.removeEventListener('scroll', onScroll);
      clearTimeout(timeoutId);
      setCookie(SEEN_COOKIE, SEEN_DAYS);
      popup.hidden = false;
      requestAnimationFrame(function () {
        popup.classList.add('is-visible');
      });
    }

    function dismissPopup() {
      popup.classList.remove('is-visible');
      setTimeout(function () {
        popup.hidden = true;
      }, 250);
    }

    function onScroll() {
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - doc.clientHeight;
      if (scrollable <= 0) return;
      if (window.scrollY / scrollable >= SCROLL_FRACTION) showPopup();
    }

    var timeoutId = setTimeout(showPopup, TIME_MS);
    window.addEventListener('scroll', onScroll, { passive: true });

    closeBtn.addEventListener('click', dismissPopup);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      if (confirmEl) confirmEl.hidden = true;
      if (errorEl) errorEl.hidden = true;
      if (submitBtn) submitBtn.disabled = true;

      fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'content-type': 'application/json', 'x-site-token': SITE_TOKEN },
        body: JSON.stringify({ email: emailInput ? emailInput.value : '' }),
      }).then(function (res) {
        if (!res.ok) throw new Error('site-newsletter POST failed: ' + res.status);
        setCookie(SUBSCRIBED_COOKIE, SUBSCRIBED_DAYS);
        form.hidden = true;
        if (confirmEl) confirmEl.hidden = false;
        setTimeout(dismissPopup, 4000);
      }).catch(function () {
        if (errorEl) errorEl.hidden = false;
        if (submitBtn) submitBtn.disabled = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-strip-10x"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTestimonials(root) {
      var track = root.querySelector('.testi10x__track');
      var cards = Array.prototype.slice.call(root.querySelectorAll('.testi10x__card'));

      cards.forEach(function (card) {
        var body = card.querySelector('.testi10x__body p');
        var more = card.querySelector('.testi10x__more');
        if (!body || !more) return;
        if (body.scrollHeight <= body.clientHeight + 1) {
          more.classList.add('is-hidden');
          return;
        }
        more.addEventListener('click', function () {
          var isOpen = card.classList.toggle('is-open');
          more.textContent = isOpen ? 'See less' : 'See more';
        });
      });

      var loop = root.querySelector('.testi10x__loop');
      var prev = root.querySelector('[data-10x-testi-prev]');
      var next = root.querySelector('[data-10x-testi-next]');
      var pauseBtn = root.querySelector('[data-10x-testi-pause]');
      if (pauseBtn && loop) {
        pauseBtn.addEventListener('click', function () {
          var paused = loop.classList.toggle('is-paused');
          pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
          pauseBtn.querySelector('.visually-hidden').textContent = paused ? 'Play testimonial scroll' : 'Pause testimonial scroll';
        });
      }
      if (loop && prev && next) {
        var offset = 0;
        var stepBy = function (dir) {
          if (!loop.classList.contains('is-manual')) {
            loop.classList.add('is-manual');
            offset = 0;
          }
          var cardWidth = cards.length ? cards[0].getBoundingClientRect().width + 32 : 340;
          var half = loop.scrollWidth / 2;
          offset -= dir * cardWidth;
          if (offset > 0) offset = -(half - cardWidth);
          if (Math.abs(offset) > half) offset = 0;
          loop.style.transform = 'translateX(' + offset + 'px)';
        };
        prev.addEventListener('click', function () { stepBy(-1); });
        next.addEventListener('click', function () { stepBy(1); });
      }
    }
    function init() {
      document.querySelectorAll('[data-10x-testimonials]').forEach(initTestimonials);
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["the-10x-system-10x"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCovers(root) {
      var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-10x-lane]'));
      var pairs = Array.prototype.slice.call(root.querySelectorAll('[data-10x-pair]'));
      if (!buttons.length) return;

      function select(index) {
        buttons.forEach(function (btn, i) {
          var on = i === index;
          var li = btn.closest('.wsc10x__item');
          var panel = li.querySelector('.wsc10x__lane-b');
          li.classList.toggle('is-active', on);
          btn.setAttribute('aria-expanded', on ? 'true' : 'false');
          if (panel) { on ? panel.removeAttribute('hidden') : panel.setAttribute('hidden', ''); }
        });
        pairs.forEach(function (pair, i) {
          pair.classList.toggle('is-active', i === index);
        });
      }

      buttons.forEach(function (btn, i) {
        btn.addEventListener('click', function () { select(i); });
        btn.addEventListener('keydown', function (e) {
          var n = buttons.length, idx = null;
          if (e.key === 'ArrowDown') idx = (i + 1) % n;
          else if (e.key === 'ArrowUp') idx = (i - 1 + n) % n;
          else if (e.key === 'Home') idx = 0;
          else if (e.key === 'End') idx = n - 1;
          if (idx !== null) { e.preventDefault(); select(idx); buttons[idx].focus(); }
        });
      });
    }
    function init() {
      document.querySelectorAll('[data-10x-covers]').forEach(initCovers);
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
